export default __webpack_public_path__ + "static/media/banner.73eb4bfc.png";